import { createContext, useCallback, useContext, useMemo, useReducer, useState } from "react";
import { StepActions } from "@/types/step-form";

const ApplicationFormContext = createContext(0);
const ApplicationFormDispatchContext = createContext<React.Dispatch<StepActions>>(() => {});
export const FormDefaultalueValueContext = createContext(null);

const initialStep: number = 0;
const fromInitialState = {};

export function ApplicationFormProvider({ children }: any) {
    const [step, dispatch] = useReducer(stepReducer, initialStep);
    const [state, formDispatch] = useReducer(reducer, fromInitialState);
    const [loadingByStep, setLoadingByStep] = useState<Record<number, boolean>>({});
    const addFormData = useCallback((key: string, data: any) => {
        formDispatch({
            type: "ADD_FORM_DATA",
            payload: {
                key,
                data,
            },
        });
    }, []);
    const removeFormData = useCallback(() => {
        sessionStorage.removeItem("enrollment_form_id");
        formDispatch({
            type: "REMOVE_FORM_DATA",
        });
    }, []);
    const setStepLoading = useCallback((stepIdx: number, isLoading: boolean) => {
        setLoadingByStep((prev) => ({
            ...prev,
            [stepIdx]: isLoading,
        }));
    }, []);
    const value = useMemo(
        () => ({
            state,
            addFormData,
            removeFormData,
            loadingByStep,
            setStepLoading,
        }),
        [state, addFormData, removeFormData, loadingByStep, setStepLoading]
    );
    return (
        <ApplicationFormContext.Provider value={step as any}>
            <ApplicationFormDispatchContext.Provider value={dispatch as any}>
                <FormDefaultalueValueContext.Provider value={value as any}>
                    {children}
                </FormDefaultalueValueContext.Provider>
            </ApplicationFormDispatchContext.Provider>
        </ApplicationFormContext.Provider>
    );
}

function reducer(state: any, action: any) {
    switch (action.type) {
        case "ADD_FORM_DATA":
            return {
                ...state,
                [action.payload.key]: action.payload.data,
            };
        case "REMOVE_FORM_DATA": {
            return {};
        }
        default:
            return state;
    }
}


function stepReducer(state: number, action: StepActions): number {
    switch (action.type) {
        case "Next":
            return state + 1;
        case "Previous":
            return state - 1;
        case "Switch":
            return action?.payload?.stepIdx ?? state;
        case "reset":
            return 0;
        default:
            throw new Error();
    }
}

export function useStep() {
    return useContext(ApplicationFormContext);
}

export function useStepDispatch() {
    return useContext(ApplicationFormDispatchContext);
}

export function useFromDefaultValue() {
    return useContext(FormDefaultalueValueContext);
}

export function useFormDefaultValueDispatch() {
    return useContext(ApplicationFormDispatchContext);
}